var _a, _b;
import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getLanguageFromStorage } from "syf-js-utilities";
import en from "./en";
import es from "./es";
export var defaultNS = "account-details-mfe";
export var resources = {
    en: (_a = {},
        _a[defaultNS] = en,
        _a),
    es: (_b = {},
        _b[defaultNS] = es,
        _b),
};
var i18n = createInstance({
    lng: getLanguageFromStorage(),
    fallbackLng: "en",
    fallbackNS: defaultNS,
    resources: resources,
    defaultNS: defaultNS,
    debug: false,
    interpolation: {
        escapeValue: false, // @note Not needed for React
    },
});
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(function (err) {
    if (err) {
        console.error("[account-details-mfe]: Translations failed to load!");
    }
});
export default i18n;
//# sourceMappingURL=i18n.js.map